export type HeaderItem = {
  text: string;
  link?: string[];
  dropdown?: {
    items: {
      text: string;
      link?: string[];
      externalLink?: string;
      icon?: string;
    }[];
  };
};

export const websiteHeaderStructure: HeaderItem[] = [
  {
    text: 'Product',
    dropdown: {
      items: [
        {
          text: 'Gallery Designer',
          link: ['/gallery-designer'],
          icon: 'annotation',
        },
        {
          text: 'Review & Approvals',
          link: ['/review-and-approvals'],
          icon: 'bolt',
        },
        {
          text: 'Advanced Mode',
          link: ['/advanced-mode'],
          icon: 'search-menu',
        },
        {
          text: 'Real Estate',
          link: ['/real-estate'],
          icon: 'office',
        },
        {
          text: 'Image Converter',
          link: ['/image-converter'],
          icon: 'arrow-swap',
        },
        {
          text: 'Feature Index',
          link: ['/feature-index'],
          icon: 'dots-grid-4',
        },
      ],
    },
  },
  {
    text: 'Pricing',
    link: ['/pricing'],
  },
  {
    text: 'Explore',
    dropdown: {
      items: [
        {
          text: 'Showcase',
          link: ['/showcase'],
          icon: 'star-filled',
        },
        {
          text: 'Enterprise',
          link: ['/enterprise'],
          icon: 'building',
        },
        {
          text: 'Security',
          link: ['/security'],
          icon: 'shield-person',
        },
        {
          text: 'Compare',
          link: ['/compare'],
          icon: 'compare',
        },
        {
          text: 'Blog',
          link: ['/blog'],
          icon: 'bookmark',
        },
        {
          text: 'Learn',
          link: ['/learn'],
          icon: 'graduate',
        },
        {
          text: 'Press',
          link: ['/press'],
          icon: 'megaphone',
        },
        {
          text: 'Support',
          externalLink: 'https://help.picflow.com',
          icon: 'question-circle',
        },
      ],
    },
  },
];
